import { useToast } from "hooks";
import { useEffect, useRef, useState } from "react";

import { put } from "utils/DeV2Api";

const useUpdateResponseFieldOption = ({
  responseFieldOptionId,
  onResponseFieldOptionUpdated,
}) => {
  const subscribedPromises = useRef([]);
  const toast = useToast();

  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [responseFieldOption, setResponseFieldOption] = useState(null);

  const updateResponseFieldOption = (responseFieldOption = {}) => {
    setError(null);
    setIsLoading(true);

    const id =
      responseFieldOptionId || responseFieldOption?.responseFieldOptionId;

    const responseFieldOptionPromise = put(`response-field-options/${id}`, {
      ...responseFieldOption,
    });
    responseFieldOptionPromise.promise
      .then(({ data }) => {
        setResponseFieldOption(data);
        if (typeof onResponseFieldOptionUpdated === "function")
          onResponseFieldOptionUpdated(data);
        toast.success("Success", "Option updated successfully");
      })
      .catch((error) => {
        !error.isCanceled && setError(error);
      })
      .finally(() => setIsLoading(false));

    subscribedPromises.current.push(responseFieldOptionPromise);
  };

  useEffect(() => {
    const promises = subscribedPromises.current;
    return () => {
      promises.forEach((promise) => {
        promise.cancel();
      });
    };
  }, []);

  return {
    error,
    setError,
    isLoading,
    responseFieldOption,
    updateResponseFieldOption,
  };
};

export default useUpdateResponseFieldOption;
